function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameLogTemplate = require('./game-log.template');

/**
 * Creates a sidebar window for a reverse-ordered list of moves that have occurred in the game.
 * By default, only displays the most recent 150 log messages and will refuse to display consecutive identical messages
 * Included in GameTemplate by default and accessible through property: log.
 * Functionality completely encoded within gameTemplate through wrapper functions updateLog (to add a message)
 * but must call render (in initializeHTML) when we want a log in our game
 *
 */
var GameLog = /*#__PURE__*/function () {
  /**
   *  @constructor
   *  @param app - Saito app
   *  @param mod - reference to the game module
   */
  function GameLog(app, mod) {
    _classCallCheck(this, GameLog);
    this.app = app;
    this.game_mod = mod;
    this.rendered = false;
    this.logs = [];
    this.log_length = 150;
    this.logs_last_msg = '';
  }

  /**
   * Adds Log to the DOM
   */
  return _createClass(GameLog, [{
    key: "render",
    value: function render() {
      try {
        if (this.logs.length === 0) {
          this.logs = _toConsumableArray(this.game_mod.game.log);
        }
      } catch (err) {}
      if (this.logs_last_msg === '' && this.logs.length > 0) {
        this.logs_last_msg = this.logs[0];
      }
      if (!document.querySelector('#log')) {
        this.app.browser.addElementToDom(GameLogTemplate());
        this.attachEvents();
      }
      var log = document.getElementById('log');
      if (log) {
        log.innerHTML = this.logs.slice(0, this.log_length).map(function (line) {
          return "<div>> ".concat(line, "</div>");
        }).join('');
      } else {
        console.error('Unable to render game log');
      }
      this.rendered = true;
    }

    /**
     * Adds functionality to open/close log by clicking (with some tolerance for click-drag actions
     */
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var xpos = 0;
      var ypos = 0;
      document.querySelector('#log').onmousedown = function (e) {
        xpos = e.clientX;
        ypos = e.clientY;
      };
      document.querySelector('#log').onmouseup = function (e) {
        if (Math.abs(xpos - e.clientX) > 4 || Math.abs(ypos - e.clientY) > 4) {
          return;
        }
        _this.toggleLog();
      };
      document.querySelector('.mobile-log-tab').onclick = function (e) {
        _this.toggleLog();
      };
    }

    /**
     * Internal function to toggle display of the log
     */
  }, {
    key: "toggleLog",
    value: function toggleLog() {
      document.querySelector('#log-wrapper').classList.toggle('log-lock');
    }

    /**
     * Add log_str to the log and run callback
     * In a bit of Twilight specific coding, log_str will not be appended if it is identical to previous log message
     * unless "force" is invoked or log_str contains either "removes" or "places" as a substring
     * @param log_str - the message to prepend to the log
     * @param force - a flag to override checks to prevent duplicate messages being logged
     *
     */
  }, {
    key: "updateLog",
    value: function updateLog(log_str) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var add_this_log_message = 1;
      if (add_this_log_message == 1 || force == 1) {
        this.logs_last_msg = log_str;
        this.logs.unshift(log_str);
        this.render(this.app, this.game_mod);
      }
    }
  }]);
}();
module.exports = GameLog;